import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { GeoPlacesServiceException as __BaseException } from "./GeoPlacesServiceException";
export class AccessDeniedException extends __BaseException {
    name = "AccessDeniedException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
        this.Message = opts.Message;
    }
}
export const TypePlacement = {
    AFTER_BASE_NAME: "AfterBaseName",
    BEFORE_BASE_NAME: "BeforeBaseName",
};
export const AutocompleteAdditionalFeature = {
    CORE: "Core",
};
export const AutocompleteFilterPlaceType = {
    LOCALITY: "Locality",
    POSTAL_CODE: "PostalCode",
};
export const AutocompleteIntendedUse = {
    SINGLE_USE: "SingleUse",
};
export const PostalCodeMode = {
    ENUMERATE_SPANNED_LOCALITIES: "EnumerateSpannedLocalities",
    MERGE_ALL_SPANNED_LOCALITIES: "MergeAllSpannedLocalities",
};
export const PlaceType = {
    BLOCK: "Block",
    COUNTRY: "Country",
    DISTRICT: "District",
    INTERPOLATED_ADDRESS: "InterpolatedAddress",
    INTERSECTION: "Intersection",
    LOCALITY: "Locality",
    POINT_ADDRESS: "PointAddress",
    POINT_OF_INTEREST: "PointOfInterest",
    POSTAL_CODE: "PostalCode",
    REGION: "Region",
    STREET: "Street",
    SUB_BLOCK: "SubBlock",
    SUB_DISTRICT: "SubDistrict",
    SUB_REGION: "SubRegion",
};
export class InternalServerException extends __BaseException {
    name = "InternalServerException";
    $fault = "server";
    $retryable = {};
    Message;
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerException.prototype);
        this.Message = opts.Message;
    }
}
export class ThrottlingException extends __BaseException {
    name = "ThrottlingException";
    $fault = "client";
    $retryable = {};
    Message;
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.Message = opts.Message;
    }
}
export const ValidationExceptionReason = {
    CANNOT_PARSE: "CannotParse",
    FIELD_VALIDATION_FAILED: "FieldValidationFailed",
    MISSING: "Missing",
    OTHER: "Other",
    UNKNOWN_FIELD: "UnknownField",
    UNKNOWN_OPERATION: "UnknownOperation",
};
export class ValidationException extends __BaseException {
    name = "ValidationException";
    $fault = "client";
    Message;
    Reason;
    FieldList;
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.Message = opts.Message;
        this.Reason = opts.Reason;
        this.FieldList = opts.FieldList;
    }
}
export const GeocodeAdditionalFeature = {
    ACCESS: "Access",
    TIME_ZONE: "TimeZone",
};
export const GeocodeFilterPlaceType = {
    INTERPOLATED_ADDRESS: "InterpolatedAddress",
    INTERSECTION: "Intersection",
    LOCALITY: "Locality",
    POINT_ADDRESS: "PointAddress",
    POSTAL_CODE: "PostalCode",
    STREET: "Street",
};
export const GeocodeIntendedUse = {
    SINGLE_USE: "SingleUse",
    STORAGE: "Storage",
};
export const PostalAuthority = {
    USPS: "Usps",
};
export const PostalCodeType = {
    USPS_ZIP: "UspsZip",
    USPS_ZIP_PLUS_4: "UspsZipPlus4",
};
export const ZipClassificationCode = {
    MILITARY: "Military",
    POST_OFFICE_BOXES: "PostOfficeBoxes",
    UNIQUE: "Unique",
};
export const RecordTypeCode = {
    FIRM: "Firm",
    GENERAL: "General",
    HIGH_RISE: "HighRise",
    POST_OFFICE_BOX: "PostOfficeBox",
    RURAL: "Rural",
    STREET: "Street",
};
export const GetPlaceAdditionalFeature = {
    ACCESS: "Access",
    CONTACT: "Contact",
    PHONEMES: "Phonemes",
    TIME_ZONE: "TimeZone",
};
export const GetPlaceIntendedUse = {
    SINGLE_USE: "SingleUse",
    STORAGE: "Storage",
};
export const ReverseGeocodeAdditionalFeature = {
    ACCESS: "Access",
    TIME_ZONE: "TimeZone",
};
export const ReverseGeocodeFilterPlaceType = {
    INTERPOLATED_ADDRESS: "InterpolatedAddress",
    INTERSECTION: "Intersection",
    LOCALITY: "Locality",
    POINT_ADDRESS: "PointAddress",
    STREET: "Street",
};
export const ReverseGeocodeIntendedUse = {
    SINGLE_USE: "SingleUse",
    STORAGE: "Storage",
};
export const SearchNearbyAdditionalFeature = {
    ACCESS: "Access",
    CONTACT: "Contact",
    PHONEMES: "Phonemes",
    TIME_ZONE: "TimeZone",
};
export const SearchNearbyIntendedUse = {
    SINGLE_USE: "SingleUse",
    STORAGE: "Storage",
};
export const SearchTextAdditionalFeature = {
    ACCESS: "Access",
    CONTACT: "Contact",
    PHONEMES: "Phonemes",
    TIME_ZONE: "TimeZone",
};
export const SearchTextIntendedUse = {
    SINGLE_USE: "SingleUse",
    STORAGE: "Storage",
};
export const SuggestAdditionalFeature = {
    ACCESS: "Access",
    CORE: "Core",
    PHONEMES: "Phonemes",
    TIME_ZONE: "TimeZone",
};
export const SuggestIntendedUse = {
    SINGLE_USE: "SingleUse",
};
export const QueryType = {
    BUSINESS_CHAIN: "BusinessChain",
    CATEGORY: "Category",
};
export const SuggestResultItemType = {
    PLACE: "Place",
    QUERY: "Query",
};
export const AccessPointFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
});
export const FilterCircleFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Center && { Center: SENSITIVE_STRING }),
});
export const AutocompleteFilterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.BoundingBox && { BoundingBox: SENSITIVE_STRING }),
    ...(obj.Circle && { Circle: SENSITIVE_STRING }),
});
export const AutocompleteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.QueryText && { QueryText: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.Filter && { Filter: AutocompleteFilterFilterSensitiveLog(obj.Filter) }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GeocodeQueryComponentsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Country && { Country: SENSITIVE_STRING }),
    ...(obj.Region && { Region: SENSITIVE_STRING }),
    ...(obj.SubRegion && { SubRegion: SENSITIVE_STRING }),
    ...(obj.Locality && { Locality: SENSITIVE_STRING }),
    ...(obj.District && { District: SENSITIVE_STRING }),
    ...(obj.Street && { Street: SENSITIVE_STRING }),
    ...(obj.AddressNumber && { AddressNumber: SENSITIVE_STRING }),
    ...(obj.PostalCode && { PostalCode: SENSITIVE_STRING }),
});
export const GeocodeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.QueryText && { QueryText: SENSITIVE_STRING }),
    ...(obj.QueryComponents && { QueryComponents: GeocodeQueryComponentsFilterSensitiveLog(obj.QueryComponents) }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GeocodeResultItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.MapView && { MapView: SENSITIVE_STRING }),
    ...(obj.AccessPoints && { AccessPoints: obj.AccessPoints.map((item) => AccessPointFilterSensitiveLog(item)) }),
});
export const GeocodeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ResultItems && { ResultItems: obj.ResultItems.map((item) => GeocodeResultItemFilterSensitiveLog(item)) }),
});
export const GetPlaceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PlaceId && { PlaceId: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GetPlaceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.MapView && { MapView: SENSITIVE_STRING }),
    ...(obj.AccessPoints && { AccessPoints: obj.AccessPoints.map((item) => AccessPointFilterSensitiveLog(item)) }),
});
export const ReverseGeocodeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.QueryPosition && { QueryPosition: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const ReverseGeocodeResultItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.MapView && { MapView: SENSITIVE_STRING }),
    ...(obj.AccessPoints && { AccessPoints: obj.AccessPoints.map((item) => AccessPointFilterSensitiveLog(item)) }),
});
export const ReverseGeocodeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ResultItems && {
        ResultItems: obj.ResultItems.map((item) => ReverseGeocodeResultItemFilterSensitiveLog(item)),
    }),
});
export const SearchNearbyFilterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.BoundingBox && { BoundingBox: SENSITIVE_STRING }),
});
export const SearchNearbyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.QueryPosition && { QueryPosition: SENSITIVE_STRING }),
    ...(obj.Filter && { Filter: SearchNearbyFilterFilterSensitiveLog(obj.Filter) }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const SearchNearbyResultItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.MapView && { MapView: SENSITIVE_STRING }),
    ...(obj.AccessPoints && { AccessPoints: obj.AccessPoints.map((item) => AccessPointFilterSensitiveLog(item)) }),
});
export const SearchNearbyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ResultItems && {
        ResultItems: obj.ResultItems.map((item) => SearchNearbyResultItemFilterSensitiveLog(item)),
    }),
});
export const SearchTextFilterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.BoundingBox && { BoundingBox: SENSITIVE_STRING }),
    ...(obj.Circle && { Circle: SENSITIVE_STRING }),
});
export const SearchTextRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.QueryText && { QueryText: SENSITIVE_STRING }),
    ...(obj.QueryId && { QueryId: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.Filter && { Filter: SearchTextFilterFilterSensitiveLog(obj.Filter) }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const SearchTextResultItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.MapView && { MapView: SENSITIVE_STRING }),
    ...(obj.AccessPoints && { AccessPoints: obj.AccessPoints.map((item) => AccessPointFilterSensitiveLog(item)) }),
});
export const SearchTextResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ResultItems && { ResultItems: obj.ResultItems.map((item) => SearchTextResultItemFilterSensitiveLog(item)) }),
});
export const SuggestFilterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.BoundingBox && { BoundingBox: SENSITIVE_STRING }),
    ...(obj.Circle && { Circle: SENSITIVE_STRING }),
});
export const SuggestRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.QueryText && { QueryText: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.Filter && { Filter: SuggestFilterFilterSensitiveLog(obj.Filter) }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const SuggestPlaceResultFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.MapView && { MapView: SENSITIVE_STRING }),
    ...(obj.AccessPoints && { AccessPoints: obj.AccessPoints.map((item) => AccessPointFilterSensitiveLog(item)) }),
});
export const SuggestResultItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Place && { Place: SuggestPlaceResultFilterSensitiveLog(obj.Place) }),
});
export const SuggestResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ResultItems && { ResultItems: obj.ResultItems.map((item) => SuggestResultItemFilterSensitiveLog(item)) }),
});
